module.exports = __webpack_public_path__ + "media/אגס.106ac517.mp3";